import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { Agent, AgentClient, DocumentTypeClient, DocumentTypes } from "src/app/web-api-client";

@Component({
  selector: 'app-documentType-creation',
  templateUrl: './documentType-creation.component.html',
  styleUrls: ['./documentType-creation.component.scss']
})
export class DocumentTypeCreationComponent implements OnInit  {

  public isLoaded = true;

   Form: FormGroup;

  public onClose = new Subject<boolean>();

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal,public client:DocumentTypeClient ) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.Form = this.fb.group({
      title: ['', Validators.required],
      isActive: [null, Validators.required]
    });
  }
  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }

  onSubmit() {
    if (this.Form.valid) {

      let service = new DocumentTypes();

      service.idDocumentType = 0;
      service.title = this.Form.value.title;
      service.isActive = this.Form.value.isActive;

      this.client.create(service).subscribe((user) => {
        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

}
